/**
 * HotspotsLayout — W1.4
 *
 * Layout-Wrapper fuer alle /hotspots-Unterseiten (Liste/Karte/Detail).
 * Design-Fix (Abnahme P1): die fruehere 4-Tab-Navigation "My / Affiliated /
 * Inactive / Neighbourhood" existiert im finalen Referenz-Prototyp
 * (hotspots.html) nicht — dort steht an ihrer Stelle nur ein Breadcrumb
 * "Hotspots > My Hotspots" (siehe ListHeader in HotspotsList.tsx). Die
 * darunterliegenden filter=affiliate/inactive/neighbour-Ansichten bleiben per
 * Deep-Link (URL-Suchparameter) erreichbar, nur die auffaellige Tab-UI faellt weg.
 */
import { Outlet } from '@tanstack/react-router'

export function HotspotsLayout() {
  return <Outlet />
}
